import { render, staticRenderFns } from "./scholarship.vue?vue&type=template&id=4ca8742d&scoped=true&"
import script from "./scholarship.vue?vue&type=script&lang=js&"
export * from "./scholarship.vue?vue&type=script&lang=js&"
import style0 from "./scholarship.vue?vue&type=style&index=0&id=4ca8742d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca8742d",
  null
  
)

export default component.exports